import { render, staticRenderFns } from "./MessageBlockQuote.vue?vue&type=template&id=64e5b6e5&scoped=true"
import script from "./MessageBlockQuote.vue?vue&type=script&lang=js"
export * from "./MessageBlockQuote.vue?vue&type=script&lang=js"
import style0 from "./MessageBlockQuote.vue?vue&type=style&index=0&id=64e5b6e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5b6e5",
  null
  
)

export default component.exports